import React, { Fragment } from 'react';
// import { Col, Form, Row } from 'react-bootstrap';
// import StopLightWithMessage from './StopLightWithMessage';
import { FrameworkcontractDataType } from './SummaryFrameworkcontractModal';
import { dateFormatter } from '@lib/helpers/formatting';
import { useQuery } from '@tanstack/react-query';
import { getOeSubjectRoles } from '@lib/api';
import { Loading } from '@components/atomic/atoms';
import SummaryInfoStatus from './SummaryInfoStatus';
import SummaryInfoList from './SummaryInfoList';
import SummaryFrameworkcontractModalInvolvedSubjects from './SummaryFrameworkcontractModalInvolvedSubjects';

interface SummaryFrameworkcontractModalInfoProps {
	frameworkcontractData: FrameworkcontractDataType;
}

const SummaryFrameworkcontractModalInfo: React.FC<SummaryFrameworkcontractModalInfoProps> = ({ frameworkcontractData }) => {
	const { data: selectedSubjectRole, isPending: isPendingSelectedSubjectRole } = useQuery<
		{
			data: { code: string; name: string }[];
		},
		Error,
		{ value: string; label: string } | undefined
	>({
		queryKey: ['subjectRoles'],
		queryFn: () => getOeSubjectRoles(),
		select: (data) => {
			const selectedItem = data.data.find((item) => item.code === frameworkcontractData?.subjectRole);

			return selectedItem ? { value: selectedItem.code, label: selectedItem.name } : undefined;
		},
		// enabled: show,
	});

	if (isPendingSelectedSubjectRole) {
		return <Loading />;
	}
	const items = [
		{
			label: 'ID Gara',
			value: frameworkcontractData.tender?.tenderNumber ?? '',
		},
		{
			label: 'CIG',
			value:
				frameworkcontractData.cigs?.map((cig) => (
					<Fragment key={cig.id}>
						{cig.cig}
						<br />
					</Fragment>
				)) ?? 'N.D.',
		},
		{
			label: 'ID Contratto',
			value: frameworkcontractData.number ?? 'N.D.',
		},
		{
			label: 'Data Sottoscrizione',
			value: frameworkcontractData?.date ? dateFormatter(frameworkcontractData?.date) : 'N.D.',
		},
		{
			label: 'Periodo di Vigenza',
			value: frameworkcontractData?.lifetime ?? 'N.D.',
		},
		{
			label: 'Estensione',
			value: frameworkcontractData?.extension ?? 'N.D.',
		},
		{
			label: 'Codice Nazione',
			value: frameworkcontractData?.countryCode ?? 'N.D.',
		},
		{
			label: 'Codice Fiscale - P.IVA Soggetto',
			value: frameworkcontractData?.vatNumber ?? 'N.D.',
		},
		{
			label: 'Ruolo Soggetto',
			value: !selectedSubjectRole ? 'N.D.' : selectedSubjectRole.label,
		},
		{
			label: 'Presenza delle Firme',
			value: frameworkcontractData?.checkSignatures ? 'Si' : 'No',
		},
	];
	return (
		<div className="summary_info-container">
			<SummaryInfoStatus entityLabel="Stato della procedura" checklistColor={frameworkcontractData.checkliststatus?.color} />

			<div>
				<h4>Dati contratto</h4>

				<SummaryInfoList items={items} />
			</div>

			<hr />
			<h4>Contratti Aperti</h4>

			<SummaryFrameworkcontractModalInvolvedSubjects frameworkcontractId={frameworkcontractData.id} />
		</div>
		// <Form className="custom-entity_modal-info_form">
		// 	<Row style={{ marginBottom: '40px' }}>
		// 		<Col
		// 			style={{
		// 				backgroundColor: '#EDF0F7',
		// 				padding: '1rem',
		// 				borderRadius: '8px',
		// 				display: 'flex',
		// 				gap: '10px',
		// 				alignItems: 'center',
		// 				justifyContent: 'space-between',
		// 				paddingBlock: '18px',
		// 			}}
		// 		>
		// 			<p
		// 				style={{
		// 					marginTop: 'auto',
		// 					marginBottom: 0,
		// 					fontWeight: 700,
		// 					fontSize: '16px',
		// 				}}
		// 			>
		// 				Stato del contratto aperto
		// 			</p>
		// 			<div
		// 				style={{
		// 					marginBottom: 'auto',
		// 				}}
		// 			>
		// 				<StopLightWithMessage checklistColor={frameworkcontractData.checkliststatus?.color} messageStyles={{ fontWeight: 500 }} />
		// 			</div>
		// 		</Col>
		// 	</Row>
		// 	<Row style={{ marginBottom: '40px' }}>
		// 		<Form.Group as={Col}>
		// 			<Form.Label>ID Gara</Form.Label>
		// 			<Form.Text as="p">{frameworkcontractData.tender?.tenderNumber ?? ''}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col}>
		// 			<Form.Label>CIG</Form.Label>
		// 			<Form.Text as="p">
		// 				{frameworkcontractData.cigs?.map((cig) => (
		// 					<Fragment key={cig.id}>
		// 						{cig.cig}
		// 						<br />
		// 					</Fragment>
		// 				)) ?? ''}
		// 			</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col}>
		// 			<Form.Label>ID Contratto</Form.Label>
		// 			<Form.Text as="p">{frameworkcontractData.number ?? 'N.D.'}</Form.Text>
		// 		</Form.Group>
		// 	</Row>

		// 	<Row style={{ marginBottom: '40px' }}>
		// 		<Form.Group as={Col}>
		// 			<Form.Label>Data Sottoscrizione</Form.Label>
		// 			<Form.Text as="p">{frameworkcontractData?.date ? dateFormatter(frameworkcontractData?.date) : 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col}>
		// 			<Form.Label>Periodo di Vigenza</Form.Label>
		// 			<Form.Text as="p">{frameworkcontractData?.lifetime ?? 'N.D.'}</Form.Text>
		// 		</Form.Group>

		// 		<Form.Group as={Col}>
		// 			<Form.Label>Estensione</Form.Label>
		// 			<Form.Text as="p">{frameworkcontractData?.extension ?? 'N.D.'}</Form.Text>
		// 		</Form.Group>
		// 	</Row>

		// 	<Row style={{ marginBottom: '40px' }}>
		// 		<Form.Group as={Col}>
		// 			<Form.Label>Codice Nazione</Form.Label>
		// 			<Form.Text as="p">{frameworkcontractData?.countryCode ?? 'N.D.'}</Form.Text>
		// 		</Form.Group>
		// 		<Form.Group as={Col}>
		// 			<Form.Label>Codice Fiscale - P.IVA Soggetto</Form.Label>
		// 			<Form.Text as="p">{frameworkcontractData?.vatNumber ?? 'N.D.'}</Form.Text>
		// 		</Form.Group>
		// 		<Form.Group as={Col}>
		// 			<Form.Label>Ruolo Soggetto</Form.Label>
		// 			<Form.Text as="p">{!selectedSubjectRole ? 'N.D.' : selectedSubjectRole.label}</Form.Text>
		// 			{/* )} */}
		// 		</Form.Group>
		// 	</Row>

		// 	<Row>
		// 		<Form.Group as={Col} className="col-4">
		// 			<Form.Label>Presenza delle Firme</Form.Label>
		// 			<Form.Text as="p">{frameworkcontractData?.checkSignatures ? 'Si' : 'No'}</Form.Text>
		// 		</Form.Group>
		// 	</Row>
		// </Form>
	);
};

export default SummaryFrameworkcontractModalInfo;
